import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Injectable()
export class DialogService {
  constructor(private dialog: MatDialog) {}

  confirm(message: string) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        message,
      },
    });
    return new Promise<boolean>((resolve) => dialogRef.afterClosed().subscribe(resolve));
  }
  // input(data: InputDialogData) {
  //   const dialogRef = this.dialog.open(InputDialogComponent, {
  //     data,
  //     width: '40%'
  //   });
  //   return new Promise<any>((resolve) => dialogRef.afterClosed().subscribe(resolve));
  // }
  open<T>(ctype: ComponentType<T>, config?: MatDialogConfig<any>) {
    let _conf: MatDialogConfig<any> = {
      width: '60%'
    };
    if (config) {
      _conf = {
        ..._conf,
        ...config
      }
    }
    return this.dialog.open<T>(ctype, _conf);
  }
  dettaglio<T>(ctype: ComponentType<T>, data: { date: Date, id_odl: number, id_odl_container_autisti: number }) {
    this.dialog.open(ctype, {
      width: '70%',
      height: '90%',
      data
    });
  }
}